/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  DayPlanningGetOverviewParams,
  DayPlanningOverviewDTO,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useDayPlanningGetOverviewHook = () => {
  const dayPlanningGetOverview = useCustomInstance<DayPlanningOverviewDTO>();

  return useCallback(
    (params?: DayPlanningGetOverviewParams, signal?: AbortSignal) => {
      return dayPlanningGetOverview({
        url: `/api/DayPlanning/GetOverview`,
        method: 'GET',
        params,
        signal,
      });
    },
    [dayPlanningGetOverview]
  );
};

export const getDayPlanningGetOverviewQueryKey = (
  params?: DayPlanningGetOverviewParams
) => {
  return [`/api/DayPlanning/GetOverview`, ...(params ? [params] : [])] as const;
};

export const useDayPlanningGetOverviewQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDayPlanningGetOverviewHook>>>,
  TError = unknown,
>(
  params?: DayPlanningGetOverviewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useDayPlanningGetOverviewHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDayPlanningGetOverviewQueryKey(params);

  const dayPlanningGetOverview = useDayPlanningGetOverviewHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useDayPlanningGetOverviewHook>>>
  > = ({ signal }) => dayPlanningGetOverview(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDayPlanningGetOverviewHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DayPlanningGetOverviewQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDayPlanningGetOverviewHook>>>
>;
export type DayPlanningGetOverviewQueryError = unknown;

export const useDayPlanningGetOverview = <
  TData = Awaited<ReturnType<ReturnType<typeof useDayPlanningGetOverviewHook>>>,
  TError = unknown,
>(
  params?: DayPlanningGetOverviewParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useDayPlanningGetOverviewHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useDayPlanningGetOverviewQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
